import { render, staticRenderFns } from "./GridSort.vue?vue&type=template&id=ed693760&scoped=true"
import script from "./GridSort.vue?vue&type=script&lang=js"
export * from "./GridSort.vue?vue&type=script&lang=js"
import style0 from "./GridSort.vue?vue&type=style&index=0&id=ed693760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed693760",
  null
  
)

export default component.exports